var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Base_Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7722_718998",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7722_718998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chat",
    d: "M8.55101 23.334L5.88167 26.003C5.50234 26.3825 5.06601 26.4679 4.57267 26.259C4.07956 26.0499 3.83301 25.6765 3.83301 25.139V5.74432C3.83301 5.07076 4.06634 4.50065 4.53301 4.03398C4.99967 3.56732 5.56979 3.33398 6.24334 3.33398H26.756C27.4296 3.33398 27.9997 3.56732 28.4663 4.03398C28.933 4.50065 29.1663 5.07076 29.1663 5.74432V20.9237C29.1663 21.5972 28.933 22.1673 28.4663 22.634C27.9997 23.1007 27.4296 23.334 26.756 23.334H8.55101ZM9.83301 18.334H17.833C18.1163 18.334 18.3538 18.2381 18.5453 18.0463C18.7371 17.8545 18.833 17.617 18.833 17.3337C18.833 17.0501 18.7371 16.8126 18.5453 16.6213C18.3538 16.4298 18.1163 16.334 17.833 16.334H9.83301C9.54967 16.334 9.31223 16.4299 9.12067 16.6217C8.9289 16.8134 8.83301 17.051 8.83301 17.3343C8.83301 17.6179 8.9289 17.8553 9.12067 18.0466C9.31223 18.2382 9.54967 18.334 9.83301 18.334ZM9.83301 14.334H23.1663C23.4497 14.334 23.6871 14.2381 23.8787 14.0463C24.0705 13.8545 24.1663 13.617 24.1663 13.3336C24.1663 13.0501 24.0705 12.8127 23.8787 12.6213C23.6871 12.4298 23.4497 12.334 23.1663 12.334H9.83301C9.54967 12.334 9.31223 12.4299 9.12067 12.6217C8.9289 12.8134 8.83301 13.051 8.83301 13.3343C8.83301 13.6179 8.9289 13.8553 9.12067 14.0467C9.31223 14.2382 9.54967 14.334 9.83301 14.334ZM9.83301 10.334H23.1663C23.4497 10.334 23.6871 10.2381 23.8787 10.0463C24.0705 9.85454 24.1663 9.61698 24.1663 9.33365C24.1663 9.05009 24.0705 8.81265 23.8787 8.62132C23.6871 8.42976 23.4497 8.33398 23.1663 8.33398H9.83301C9.54967 8.33398 9.31223 8.42987 9.12067 8.62165C8.9289 8.81343 8.83301 9.05098 8.83301 9.33432C8.83301 9.61787 8.9289 9.85532 9.12067 10.0467C9.31223 10.2382 9.54967 10.334 9.83301 10.334Z",
    fill: "#6852D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.5adfcfafa4cc0d3031845fe2a23b6630.svg";
export { ForwardRef as ReactComponent };